<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5  background_color " >
              <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Vehicle Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/Svehicleinvoice/Index">Manage Vehicle Invoice </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Invoice </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div  class="container-fluid ">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">

  



   

                    <form @submit.prevent="SaveAlldata()" >


<div class="row">


    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Sales order</label>
            <input  v-model="all_data.so_code"  style="font-size: small;" class="form-control" required>
           
    </div>
  </div>

    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Customer</label>
            <input  v-model="all_data.user_full_name"  style="font-size: small;" class="form-control" required>
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Dealer</label>
            <input  v-model="all_data.C_name"  style="font-size: small;" class="form-control" required>
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Sales Rep.</label>
            <input  v-model="all_data.name1"  style="font-size: small;" class="form-control" required>
           
    </div>
  </div>
   

</div>

<div class="row">

    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Invoice Date</label>
            <input type="date"  v-model="all_data.invoice_date"  style="font-size: small;" class="form-control" required>
           
    </div>
  </div>

<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Remarks</label>
        <textarea v-model="all_data.remarks" class="form-control" rows="2"></textarea>
       
</div>
</div>





</div>






<div class="card custom_bdr_rds">
                        <div class="card-body custom_bdr_rds">
                         

                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                          <thead class="background_color2">
                            <tr class="custom-label2">
                              <th>Make</th>
                              <th>Model</th>
                              <th>Color</th>
                              <th >Engine No.</th>
                              <th >Chassis No.</th>
                              <th  style="text-align: right;">Amount</th>
                            
                              </tr>
                            </thead>
                            <tbody>
                              <!-- //  v-for="(detail, index) in details" :key="detail.id" -->
                              <tr >
                              <td>{{ all_data.brandname }}</td>
                              <td>{{ all_data.modelname }}</td>
                              <td>{{ all_data.colorcode }}</td>
                              <td>{{ all_data.engineno }}</td>
                              <td>{{ all_data.chassisno }}</td>
                              <td style="text-align: right;">{{ all_data.price }}</td>
                             
                            
                              </tr>
                              <tr  >
                              <td></td>
                              <td></td>
                              <td>Discount</td>
                              <td></td>
                             
                              <td></td>
                              <td  style="text-align: right;">{{  all_data.discount_amount }}</td>
                             
                            
                              </tr>
                              <tr >
                              <td></td>
                              <td></td>
                              <td>Total</td>
                              <td></td>
                        
                              <td></td>
                              <td  style="text-align: right;">{{ all_data.total  }}</td>
                             
                            
                              </tr>
                              
                              <tr v-show="all_data.po_value!=0">
                              <td></td>
                              <td></td>
                              <td>Leasing PO</td>
                              <td></td>
                            
                              <td></td>
                              <td  style="text-align: right;">{{ all_data.po_value  }}</td>
                             
                            
                              </tr>
                              <tr >
                              <td></td>
                              <td></td>
                              <td>Advance</td>
                              <td></td>
                             
                              <td></td>
                              <td  style="text-align: right;">{{all_data.advance}}</td>
                             
                            
                              </tr>
                              
                              <tr >
                              <td></td>
                              <td></td>
                              <td>Balance Payable</td>
                              <td></td>
                           
                              <td></td>
                              <td  style="text-align: right;">{{all_data.balance}}</td>
                             
                            
                              </tr>
                             
                             
                            </tbody>

                          </table>


                        </div>
                    </div>

























    

    <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>

  
 



    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadAlldata();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            count: 0,
        total:{},
        selectedOption: null, // Store the selected option
        
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        qty:0,
        selectedAccessories: [],
        brokerShow:false,
        mcustomers:[],
        mproducts:[],
        engines:[],
        brokers:[],
        contacts:[],
      salespeoples:[

      ],
      subtotal:{},
      errors: {},
      discount:0,
      squatation:{},
        customer:{},
        quotation:{
          'validity_period':{
            label: 'Select Validity Period', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
      
        // Brands:[],
        all_reps:[],
        engins:[],
        all_data:{},
        details:[],
    

        validity_periodop: [
            { label: 'Select Validity Period', value: '' },
            { label: '7 Days', value: '7 Days' },
            { label: '14 Days', value: '14 Days' },
          
           
        ],
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {

          async spe_dis() {
        const sub = this.total -this.discount;
        this.subtotal = sub.toFixed(2);
     },
    async loadAlldata() {
       
     
       try {
         const { data} = await  axios.get('/svehicleinvoice/loaddata?id='+this.id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.all_data = data.all_data;
        //   this.details = data.details;
        //   this.total = data.total;
        //   this.subtotal = data.total- this.discount;
       
         
       } catch (error) {
         console.log(error.response);
       }



     },

     async SaveAlldata() {
       
     
       try {
         const { data} = await  axios.post('/svehicleinvoice/create',{userid:this.userid,id:this.id,all_data:this.all_data},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
          this.$router.push('/svehicleinvoice/index');
        }
       
         
       } catch (error) {
         console.log(error.response);
       }



     },

    
       
     
       
   

     

    

    

    
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    